export const T = {
  en_GB: {
    textFormatError: "Each line must be: date;value (e.g., 2026-01-06;102.5)",
  },
  nb_NO: {
    textFormatError: "Hver linje må være: dato;verdi (f.eks. 2026-01-06;102.5)",
  },
} as const;
